export const AUTH = 'AUTH'
export const AUTH_EXTERNAL = 'AUTH_EXTERNAL'
export const LOGOUT = 'LOGOUT'
export const SAVE_PROFILE = 'SAVE_PROFILE'
export const SET_INTENDED_URL = 'SET_INTENDED_URL'
